import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Compromisos y declaraciones", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Documentos soporte", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", {
  class: "titleDD",
  style: {"padding-top":"1em"}
}, "Firma", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "adicional-dialog" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Cumplimiento de buenas prácticas y compromiso LAFT *")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", { style: {"list-style-type":"none"} }, " En nombre propio o en representación de una persona natural o jurídica, todo lo cual se encuentra legalmente acreditado, me permito declarar que: "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, " El negocio y los recursos que utiliza para la ejecución y desarrollo normal de las actividades, no provienen de ninguna actividad ilícita de las contempladas en el Código Penal Colombiano o en cualquier norma que lo modifique o adicione. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " El negocio cumple con las normas y regulaciones colombianas relacionadas con la prevención y control al lavado de activos y al financiamiento del terrorismos que le son aplicables. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " El negocio cuenta con políticas, manuales y procedimientos de prevención y control al lavado de activos y a la financiación del terrorismo, quedan cabal al cumplimiento a las regulaciones vigentes que le son aplicables. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Ni los accionistas o asociados se encuentran vinculados en las listas restrictivas (Listas de las Naciones Unidas o de la OFAC), o han sido sancionados, ni existe en curso investigaciones o procesos penales por delitos relacionados con LA/FT. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Me comprometo a comunicar a Aportes en Línea sobre cualquier evento relacionado en los numerales anteriores, en el momento en que tenga conocimiento de que alguno de estos ocurra. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Me comprometo a entregar a Aportes en Línea toda la información que le sea solicitada para dar cumplimiento a las disposiciones relacionadas con la Prevención del Lavado de Activos y Financiación del Terrorismo y declaro que la misma es veraz y verificable. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " En el evento en que no cumpla con las presentes declaraciones y eventuales obligaciones definidas en los contratos que lleguen a celebrarse con Aportes en Línea, Aportes en Línea podrá dar por terminado el contrato de manera inmediata, sin que por este hecho haya lugar al pago de sanción o indemnización alguna, bastará la comunicación por escrito, incluyendo el correo electrónico, que sobre esta decisión haya tomado Aportes en Línea. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " El Representante Legal autoriza a Aportes en Línea, y a quien en el futuro represente sus derechos, de manera irrevocable, para consultar y reportar a cualquier entidad que maneje o administre bases de datos que tengan fines de información, financieros, estadísticos, de control, supervisión, gerenciales y de consolidación de información, todos los datos económicos, incluyendo la información referente a su comportamiento comercial y crediticio. Como consecuencia de esta autorización Aportes en Línea podrá consultar e incluir sus datos financieros y comerciales en las bases de datos antes mencionadas, en las cuales se verá reflejado su actual y pasado comportamiento en relación con el cumplimiento o incumplimiento de sus obligaciones, información que permanecerá reportada por los términos previstos en la Ley o en su defecto en los reglamentos de dichas sociedades. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Autorizo a Aportes en Línea, y a quien en el futuro represente sus derechos, de manera expresa e irrevocable, para que Aportes en Línea o las empresas del Grupo Aval, Acciones y Valores S.A., tengan acceso a toda la información y documentación que tenga relación con la presente declaración. "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "adicional-dialog" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Declaración de información suministrada exacta")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " DECLARACIÓN EN NOMBRE PROPIO O EN REPRESENTACIÓN DE UN TERCERO, FACTULTADO QUE SE ENCUENTRE DEBIDAMENTE ACREDITADA ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " En nombre propio o en representación de una persona natural o jurídica, todo lo cual se encuentra legalmente acreditado, me permito manifestar bajo la gravedad de juramento que toda la información relacionada o adjunta a éste formulario, es veraz, exacta y verificable; en consecuencia otorgo autorización a Aportes en Línea S.A., sociedad comercial, legalmente constituida en Colombia e identificada con el NIT. 900.147.238-2 para que consulte centrales de riesgos tales como listas de las Naciones Unidas, OFAC, terroristas EEUU, terroristas UE u otros, a efectos de validar cada uno de los datos plasmados en éste documento, así como la información entregada en los soportes que forman parte del mismo. Así mismo autorizo a Aportes en Línea S.A. a acudir a los Operadores de Información para consultar el pago de aportes al Sistema General de Seguridad Social y Parafiscales e igualmente en la lista SAGRILAFT ( Sistema de Autocontrol y Gestión del Riesgo Integral LA/FT - Lavado de Activos, la Financiación del Terrorismo y el Financiamiento de la Proliferación de Armas de Destrucción Masiva). Lo expuesto con el propósito de realizar el debido conocimiento de la contraparte. Autorización que permanecerá vigente por la existencia de la relación contractual. ", -1)
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "auto",
    class: "greenItem"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Cumplimiento de buenas prácticas y compromiso LAFT*" }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mostrarMensajeLAFT = true)),
                      class: "link-modal"
                    }, "Leer")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.objetoArchivos.BuenasPracticas,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objetoArchivos.BuenasPracticas) = $event)),
                placeholder: "Seleccionar",
                class: "selectDD"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.codigo,
                      label: item.valor,
                      value: item.valor
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.BuenasPracticas.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Declaración de Conflicto de interés*" }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mostrarMensajeDeclaracion = true)),
                    class: "link-modal"
                  }, "Leer")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.objetoArchivos.ConflictoInteres,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objetoArchivos.ConflictoInteres) = $event)),
                placeholder: "Seleccionar",
                class: "selectDD"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.generico, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.codigo,
                      label: item.valor,
                      value: item.valor
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.ConflictoInteres.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_el_form_item, {
                id: "bold-file",
                label: "En caso de querer adjuntar mas de un documento, da clic sobre el botón ' + '"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                id: "bold-file",
                label: "En caso de requerir eliminar uno de los documentos, da clic en ' x ' "
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                id: "bold-file",
                label: "Los tipos de archivos permitidos para cargar documentos son .pdf, .jpg y .png "
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                id: "bold-file",
                label: "El tamaño máximo de todos los archivos cargados es de 20 MB "
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Documento de identidad de personas naturales y representantes principales.*" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Original certificado de existencia y representación legal no mayor a 30 días.(Obligatorio para quienes tienen registro de su actividad económica ante la Cámara de comercio)" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.DocumentosIdentidad.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.Certificados.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarDocumentoIdentidad,
                "on-change": _ctx.CargarDocumentoIdentidad,
                "file-list": _ctx.documentosIdentidad,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Adjuntar +")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.DocumentosIdentidad.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objetoArchivos.DocumentosIdentidad.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarCertificado,
                "on-change": _ctx.CargarCertificado,
                "file-list": _ctx.certificados,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Adjuntar +")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.Certificados.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objetoArchivos.Certificados.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12,
            style: {"padding-top":"15px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "RUT.*" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12,
            style: {"padding-top":"15px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Estados financieros." })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.RUT.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.EstadosFinancieros.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.EstadosFinancieros.InformacionFinanciera.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarRUT,
                "on-change": _ctx.CargarRUT,
                "file-list": _ctx.RUTs,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Adjuntar +")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.RUT.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objetoArchivos.RUT.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarEstadoFinanciero,
                "on-change": _ctx.CargarEstadoFinanciero,
                "file-list": _ctx.estadosFinancieros,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Adjuntar +")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.EstadosFinancieros.InformacionFinanciera,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objetoArchivos.EstadosFinancieros.InformacionFinanciera) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.EstadosFinancieros.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objetoArchivos.EstadosFinancieros.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.TamañoArchivo,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objetoArchivos.TamañoArchivo) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.NombresArchivos,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objetoArchivos.NombresArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_el_form_item, { label: "Por favor descarga el documento que encuentras a continuación y diligencia los datos correspondientes. \r\n          Cuando tengas la información debidamente diligenciada, adjunta el archivo para finalizar el proceso. El documento debe\r\n          llamarse 'CartaFirmaRepresentante' y su formato debe ser .pdf*." })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, [
                _createElementVNode("a", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.Download('CartaFirmaRepresentante.pdf'))),
                  class: "cartaDownload"
                }, "Descargar documento")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.Firma.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.Firma.Nombre.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarFirma,
                "on-change": _ctx.CargarFirma,
                limit: 1,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Adjuntar")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.Firma.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objetoArchivos.Firma.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.Firma.Nombre,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.objetoArchivos.Firma.Nombre) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.NombresArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.TamañoArchivo.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.mostrarMensajeLAFT,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mostrarMensajeLAFT) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { style: {"padding-right":"2em"} }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_el_button, {
                  type: "success",
                  plain: "",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.mostrarMensajeLAFT = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Aceptar")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.mostrarMensajeDeclaracion,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mostrarMensajeDeclaracion) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { style: {"padding":"2em","text-align":"justify"} }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_el_button, {
                  type: "success",
                  plain: "",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.mostrarMensajeDeclaracion = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Aceptar")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}